import React from 'react'
import Icon from 'blocks.simple/icon/icon'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import styles from './catalog__template_videoEditorTasks.jcss'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import store from 'core/store'

const getActionIcon = (action) => {
    switch (action) {
        case 'removeAudio':
            return 'volume_mute'
        case 'convertToMp4':
            return 'mp4'
        case 'setVideoBitrate':
            return 'bitrate'
        case 'imageToVideo':
            return 'planning'
        case 'fadeIn':
        case 'fadeOut':
            return null
        case 'setFps':
            return 'frames'
        default:
            return action
    }
}

export default {
    getMethod: 'getVideoEditorTasks',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noTasks'),
    emptyIcon: 'not_allow',
    settingsPrefixes: 'videoEditorTasks',
    listWrapperClassName: styles.list,
    fields: () => [
        { id: 'fileName', name: translate('name') },
        { id: 'commands', name: translate('actions') },
        { id: 'status', name: translate('status') },
    ],
    sortOptions: () => [
        { id: '-status', name: translate('sortStatus') },
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: '-id', name: translate('id') },
    ],
    getItemModel: (dataItem, getSelected) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    isEqual: (firstItem, secondItem) => firstItem.id === secondItem.id,
    onCreateListeners: [(cb, clearList) => api.addObserver('videoEditorTaskCreated', cb, clearList)],
    onUpdateListeners: [(cb, clearList) => api.addObserver('videoEditorTaskUpdated', cb, clearList)],
    onDeleteListeners: [(cb, clearList) => api.addObserver('videoEditorTaskDeleted', cb, clearList)],
    init(callback) {
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    onDeleteListItem(item) {
        const disabled = ['in_queue', 'in_progress']

        if (disabled.includes(item.status)) {
            store.dispatch(emitError('cannotDeleteTaskInProcess'))
            return
        }

        api.send('deleteVideoEditorTask', { id: item.id })
    },
    tableWrapper: styles.tableWrapper,
    list: {
        fileName: ({ data }) => data.fileName,
        commands: ({ commands }, active) => (
            <div className={cn(grid.row, grid.justify, grid.noWrap)}>
                {commands &&
                    commands.map((command) => (
                        <Icon
                            containerClass={cn(grid.ml_micro, grid.mr_micro)}
                            key={command.action}
                            type={getActionIcon(command.action)}
                            color={active ? 'white' : 'grey'}
                        />
                    ))}
            </div>
        ),
        status: ({ status }) => translate(`videoEditor_${status}`),
    },
}
